module.exports = __webpack_public_path__ + "static/img/none-data.cc273d41.png";